import axiosInstance from '../utils/axios';

const apkService = {
  buildApk: async ({ appName, baseApiUrl, packageName, iconFile }) => {
    const form = new FormData();
    if (appName) form.append('appName', appName);
    if (baseApiUrl) form.append('baseApiUrl', baseApiUrl);
    if (packageName) form.append('packageName', packageName);
    if (iconFile) form.append('icon', iconFile);

    // ВАЖНО: не указывать Content-Type вручную — браузер добавит boundary автоматически
    const response = await axiosInstance.post('/apk/build', form, {
      responseType: 'blob'
    });
    return response;
  }
};

export default apkService;
